'use client';

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';
import PDFViewer from '@/components/shared/PDFViewer';
import { PDF_MAP } from '@/data/pdfMap';
import NotFound from '@/app/not-found';
import { trackEvent } from '@/lib/umami';
export default function PDFPageClient() {
  const $ = _c(17);
  const searchParams = useSearchParams();
  const trackedKeyRef = useRef(null);
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("id");
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const id = t0;
  let t1;
  if ($[2] !== searchParams) {
    t1 = searchParams.get("url");
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const urlParam = t1;
  let t2;
  if ($[4] !== searchParams) {
    t2 = searchParams.get("title");
    $[4] = searchParams;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const titleParam = t2;
  const mappedPdf = id ? PDF_MAP[id] : undefined;
  const pdfUrl = urlParam ?? mappedPdf?.url ?? null;
  const pdfTitle = urlParam ? titleParam || "PDF Document" : mappedPdf?.title ?? null;
  const notFound = !pdfUrl || !pdfTitle;
  let t3;
  let t4;
  if ($[6] !== id || $[7] !== pdfTitle || $[8] !== pdfUrl || $[9] !== titleParam || $[10] !== urlParam) {
    t3 = () => {
      if (!pdfUrl || !pdfTitle) {
        trackedKeyRef.current = null;
        return;
      }
      const trackKey = `${id || ""}|${urlParam || ""}|${titleParam || ""}|${pdfUrl}`;
      if (trackedKeyRef.current === trackKey) {
        return;
      }
      trackedKeyRef.current = trackKey;
      const source = urlParam ? "url_param" : id ? "mapped" : "unknown";
      const referrer = typeof document !== "undefined" ? document.referrer : "";
      trackEvent("pdf_page_view", {
        pdf_id: id || undefined,
        title: titleParam || pdfTitle,
        source,
        referrer: referrer || undefined
      });
    };
    t4 = [id, pdfTitle, pdfUrl, titleParam, urlParam];
    $[6] = id;
    $[7] = pdfTitle;
    $[8] = pdfUrl;
    $[9] = titleParam;
    $[10] = urlParam;
    $[11] = t3;
    $[12] = t4;
  } else {
    t3 = $[11];
    t4 = $[12];
  }
  useEffect(t3, t4);
  if (notFound) {
    let t5;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <NotFound />;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    return t5;
  }
  let t5;
  if ($[14] !== pdfTitle || $[15] !== pdfUrl) {
    t5 = <PDFViewer url={pdfUrl} title={pdfTitle} />;
    $[14] = pdfTitle;
    $[15] = pdfUrl;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}